import type { GuestQuoteClosedStatus, GuestQuoteView } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { GuestQuoteSupport } from './guest-quote-support';

interface ClosedCopy {
  readonly title: string;
  readonly description: string;
}

/** 끝난 상태별 안내 — 반려·취소·만료·거절(결정 G9). */
const CLOSED_COPY: Readonly<Record<GuestQuoteClosedStatus, ClosedCopy>> = {
  REJECTED: {
    title: '견적을 드리기 어려운 요청이에요',
    description: '검토 결과 이 요청은 제작이 어려워 견적을 드리지 못했어요.',
  },
  CANCELED: {
    title: '취소된 견적 요청이에요',
    description: '이 견적 요청은 취소되었어요.',
  },
  EXPIRED: {
    title: '유효기간이 지난 견적이에요',
    description: '견적서의 유효기간이 지나 더 이상 주문할 수 없어요.',
  },
  DECLINED: {
    title: '거절한 견적이에요',
    description: '이 견적은 거절되어 더 이상 주문할 수 없어요.',
  },
};

export interface GuestQuoteClosedProps {
  readonly view: Extract<GuestQuoteView, { state: 'CLOSED' }>;
}

/** 끝남(결정 G9) — 상태 안내와 접수번호, 고객센터만 보여 준다. 견적 내용은 응답에 없다. */
export const GuestQuoteClosed = ({ view }: GuestQuoteClosedProps): ReactElement => {
  const copy = CLOSED_COPY[view.status];

  return (
    <div className="flex flex-col gap-12">
      <section className="flex flex-col items-center gap-3 border-y border-foreground/10 py-24 text-center">
        <h1 className="text-2xl font-bold tracking-[-0.02em] sm:text-3xl">{copy.title}</h1>
        <p className="text-sm text-muted-foreground tabular-nums">접수번호 {view.quoteNumber}</p>
        <p className="text-sm text-muted-foreground">
          {copy.description} 다시 상담이 필요하면 고객센터로 연락 주세요.
        </p>
      </section>
      <GuestQuoteSupport />
    </div>
  );
};
